var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.54 7V6C10.54 5.86458 10.4906 5.7474 10.3916 5.64844C10.2926 5.54948 10.1755 5.5 10.04 5.5H7.54004V3C7.54004 2.86458 7.49056 2.7474 7.3916 2.64844C7.29264 2.54948 7.17546 2.5 7.04004 2.5H6.04004C5.90462 2.5 5.78744 2.54948 5.68848 2.64844C5.58952 2.7474 5.54004 2.86458 5.54004 3V5.5H3.04004C2.90462 5.5 2.78743 5.54948 2.68848 5.64844C2.58952 5.7474 2.54004 5.86458 2.54004 6V7C2.54004 7.13542 2.58952 7.2526 2.68848 7.35156C2.78743 7.45052 2.90462 7.5 3.04004 7.5H5.54004V10C5.54004 10.1354 5.58952 10.2526 5.68848 10.3516C5.78744 10.4505 5.90462 10.5 6.04004 10.5H7.04004C7.17546 10.5 7.29264 10.4505 7.3916 10.3516C7.49056 10.2526 7.54004 10.1354 7.54004 10V7.5H10.04C10.1755 7.5 10.2926 7.45052 10.3916 7.35156C10.4906 7.2526 10.54 7.13542 10.54 7ZM12.54 2.75V10.25C12.54 10.8698 12.32 11.3997 11.8799 11.8398C11.4398 12.2799 10.9098 12.5 10.29 12.5H2.79004C2.17025 12.5 1.6403 12.2799 1.2002 11.8398C0.760091 11.3997 0.540039 10.8698 0.540039 10.25V2.75C0.540039 2.13021 0.760091 1.60026 1.2002 1.16016C1.6403 0.720052 2.17025 0.5 2.79004 0.5H10.29C10.9098 0.5 11.4398 0.720052 11.8799 1.16016C12.32 1.60026 12.54 2.13021 12.54 2.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.f4aaf45c6cc68d6b73dd0dfc2ec1a965.svg";
export { ForwardRef as ReactComponent };